import { MAX_OTHER_FILE_NUMBER } from 'hooks/uploadFile.hook';
import { FC } from 'react';
import { Box, Stack } from 'styles';
import { IFileType } from 'types/Claim';
import { DocType } from 'types/Upload';
import BeforeUpload from './BeforeUpload';
import ManyAttachmentRow from './ManyAttachmentRow';

type UploadManyTileProps = {
	documentType: DocType;
	data?: IFileType[];
};

const UploadManyTile: FC<UploadManyTileProps> = ({ documentType, data }) => {
	return (
		<Box width={'100%'} minHeight={{ sm: '210px', lg: '240px' }}>
			<Stack direction={'column'} gap={'20px'}>
				<BeforeUpload
					documentType={documentType}
					maxFileNumber={
						data ? MAX_OTHER_FILE_NUMBER - data.length : MAX_OTHER_FILE_NUMBER
					}
				/>
				{data?.map((attachment, index) => (
					<ManyAttachmentRow
						key={index}
						data={attachment}
						documentType={documentType}
					/>
				))}
			</Stack>
		</Box>
	);
};

export default UploadManyTile;
